import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSLookup = {
    name: 'VS Vulnerability Lookup',
    imageUrl: '../../images/VSLookup.png',
    imageSize: "99%",
    bradius: 20,
  };


export const VSLookup = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Vulnerability Lookup </b><br/><br/>
      The Vulnerability Lookup feature allows you to look up details about a specific CVE. 
      If the scope of the search criteria is too broad, results will be limited to 500 CVEs. <br/><br/>

      Best practice is to apply a search with a known CVE number or a part of the number.  <br/><br/>

      Enter the CVE number into the search box and click on Start Search. The resulting 
      display will show you the vulnerability, the description, and the severity rating 
      for that vulnerability, with score ratings from 0 - 10 (10 being critical). <br/><br/>

      To drill-down and get more information on a specific vulnerability, click on the CVE 
      number. This will show you the CVE published date, and the Operating System and 
      Applications affected by it.  <br/><br/>
      
      To mitigate or manage risk, click on the View Solution link provided in the display. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSLookup.imageUrl}
        alt={'Image of ' + UIVSLookup.name}
        style={{
          width: UIVSLookup.imageSize,
          borderRadius: UIVSLookup.bradius,
        }}
      />
      </div>
    </div>
  );
};
